import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safeWidget' })
export class SafeWidgetPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) { }
    transform(widget) {
        let frameDomain = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/v2/#/';
		let componentRoute = 'widget-frame';
		let widgetQuery = 'widgetMode=true';
        let connectedExperience = widget.connectedExperience;

        if (process.env.config.isDevelopment) {
			frameDomain = 'http://localhost:4200/#/';
			connectedExperience = 'example-app';
		}

		return this.sanitizer.bypassSecurityTrustResourceUrl(`${frameDomain}${componentRoute}?${widgetQuery}&experienceName=${connectedExperience}&widgetName=${widget.componentId}`);
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/components/pipes/safe-widget.pipe.ts